var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5674 7.14938V12.8493C17.5674 13.7827 17.0674 14.6494 16.2591 15.1244L11.3091 17.9827C10.5008 18.4494 9.50078 18.4494 8.68411 17.9827L3.73411 15.1244C2.92578 14.6577 2.42578 13.791 2.42578 12.8493V7.14938C2.42578 6.21604 2.92578 5.34934 3.73411 4.87434L8.68411 2.01602C9.49245 1.54935 10.4924 1.54935 11.3091 2.01602L16.2591 4.87434C17.0674 5.34934 17.5674 6.20771 17.5674 7.14938Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 10.0005C11.0726 10.0005 11.9419 9.13117 11.9419 8.05882C11.9419 6.98646 11.0726 6.11719 10.0003 6.11719C8.92791 6.11719 8.05859 6.98646 8.05859 8.05882C8.05859 9.13117 8.92791 10.0005 10.0003 10.0005Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2336 13.8846C12.9086 13.8846 13.3003 13.1346 12.9253 12.5763C12.3586 11.7346 11.2586 11.168 10.0003 11.168C8.74196 11.168 7.64196 11.7346 7.0753 12.5763C6.7003 13.1346 7.09196 13.8846 7.76696 13.8846H12.2336Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.77f96ff7f6d7593a91b4243198891777.svg";
export { ForwardRef as ReactComponent };